/* eslint-disable i18next/no-literal-string */
import { useQuery } from '@apollo/react-hooks';
import _ from 'lodash';

import filteredSpecialsQuery from 'shared/graphql/special/queries/filtered-specials.gql';

export default function useProductOffers(product) {
  const { data: queryResults, loading } = useQuery(filteredSpecialsQuery, {
    fetchPolicy: 'network-only',
    skip: _.isEmpty(product.specialData?.bogoSpecials),
    variables: {
      specialsFilter: {
        dispensaryId: product.DispensaryID,
        current: true,
        specialIds: _.map(product.specialData?.bogoSpecials || [], 'specialId'),
      },
    },
  });

  return { specials: queryResults?.filteredSpecials?.specials || [], loading };
}
